<template>
  <div class="home-list-wrap">
    <div class="home-words-wrap">
      <div class="words-swiper-wrap">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          :auto-update="true"
          :auto-destroy="true"
        >
          <template v-for="(word,index) in words">
            <swiper-slide :key="index">
              <div
                :class="['word-wrap',current_word[type+'_id'] == word[type+'_id'] ? 'word-active' : '']"
                @click="wordClick(word)"
              >
                <span class="word-text">{{word[type+'_name']}}</span>
              </div>
            </swiper-slide>
          </template>
        </swiper>
      </div>
      <div class="words-more">
        <img
          class="words-more-img"
          alt=""
          src="@/assets/images/word_more.png"
        >
        <span
          class="words-more-text"
          @click="$emit('word-more-click',{type,word:current_word})"
        >更多</span>
      </div>
    </div>
    <div
      class="home-list-content"
      :style="{height:content_height}"
    >
      <template v-if="list_data && list_data.length > 0">
        <list
          v-model="loading"
          :finished="finished"
          :finished-text="finished_text"
          @load="onLoad"
        >
          <div class="homt-list-item-wrap">
            <template v-for="(item,index) of list_data">
              <home-list-item
                :data="item"
                :key="index"
                :index="index"
                @item-click="itemClick"
              >
              </home-list-item>
            </template>
          </div>
        </list>
      </template>
      <div
        v-else
        class="no-expert"
      >
        <div class="no-data">
          <div class='img-outer'>
            <img
              src="@/assets/images/comment/zanwu.png"
              alt=""
            />
          </div>
        </div>
        <p class="no-data-title">
          暂无教学
        </p>
      </div>
    </div>
  </div>

</template>
<script>
import { List } from "vant";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import HomeListItem from "./HomeListItem";
import Request from "@request";
import api from "@api";

export default {
  components: {
    List,
    Swiper,
    SwiperSlide,
    HomeListItem,
  },
  directives: {
    swiper: directive,
  },
  props: {
    content_height: String,
    type: String,
    words: Array,
    sysusers_id: Number,
  },
  data() {
    return {
      loading: true,
      finished: false,
      swiperOptions: {
        freeMode: true,
        freeModeMomentumRatio: 0.5,
        slidesPerView: "auto",
      },
      current_word: {},
      list_data: [],
      page: 1,
      finished_text: "",
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    sysusers_id(val) {
      this.sysusers_id = val;
      this.getProductionList(false);
    },
  },
  created() {
    this.getProductionList(false);
  },
  mounted() {},
  methods: {
    getProductionList(load_more) {
      console.log(this.sysusers_id, load_more,  "______________");
      if (load_more) {
        this.page++;
      } else {
        this.page = 1;
      }
      this.loading = true;
      const { disease_id = 0, department_id = 0 } = this.current_word;
      Request.post(api.home.production_list, {
        page: this.page,
        disease_id,
        department_id,
        sysusers_id: this.sysusers_id,
      }).then((res) => {
        this.loading = false;
        const { data } = res;
        if (load_more) {

          console.log(data, "-------")
          this.list_data = [...this.list_data, ...data.list];
          this.finished = data.list.length < 20 || data.list.length == 0 ? true : false;
        } else {
          this.finished = data.list.length < 20 || data.list.length == 0 ? true : false;
          this.list_data = data.list;
        }

        
        if (this.list_data && this.list_data.length > 8) {
          this.finished_text = "- 我也是有底线的 -";
        }
      });
    },
    getData(word, params, index) {
      if (index != null || index != undefined) {
        this.swiper.slideTo(index, 1000, false);
      }
      this.page = 1;
      this.loading = true;
      const { disease_id = 0, department_id = 0 } = word;
      this.current_word = word;
      Request.post(api.home.production_list, params).then((res) => {
        const { data } = res;
        this.list_data = data.list;
        if (this.page >= data.last_page) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.loading = false;
        if (this.list_data && this.list_data.length > 8) {
          this.finished_text = "- 我也是有底线的 -";
        }
      });
    },
    onLoad() {
      console.log(this.sysusers_id);
      this.getProductionList(true);
    },
    wordClick(word) {
      this.current_word = word;
      this.getProductionList(false);
    },
    itemClick(item) {
      const { production_id } = item;
      this.$router.push({
        name: "DoctorProduction",
        query: {
          production_id,
        },
      });
    },
  },
};
</script>
<style>
.swiper-slide {
  width: auto;
}
</style>
<style scoped>
.home-list-wrap {
  width: 93.44%;
  margin: 0.5rem auto;
  background: #f4f4f4;
}

.home-words-wrap {
  display: flex;
  flex-direction: row;
}

.words-swiper-wrap {
  flex: 1;
  width: 0;
}

.words-more {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 0.7rem;
}

.words-more-img {
  height: 0.9rem;
}

.words-more-text {
  display: inline-block;
  width: 1.3rem;
  margin-left: 0.1rem;
  font-size: 0.51rem;
  color: #222222;
}

.word-wrap {
  margin-bottom: 0.7rem;
  height: 1.09rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0rem 0.36rem;
  background-color: #ffffff;
  border-radius: 0.17rem;
  cursor: pointer;
}

.swiper-slide:not(:first-child) {
  margin-left: 0.5rem;
}

.word-text {
  font-size: 0.51rem;
  color: #222222;
}

.word-active {
  background-color: #dfe6ff;
  box-shadow: 0rem 0.13rem 0.26rem 0rem rgba(18, 68, 241, 0.2);
  border-radius: 0.17rem;
}

.word-active .word-text {
  color: #1244f1;
}

.home-list-content {
  margin-left: -3.33%;
  margin-right: -3.33%;
  padding: 0 3.33% 0 3.33%;
  margin-top: 0.4rem;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.homt-list-item-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.no-expert {
  width: 100%;
  height: 8.76rem;
  background: #f4f4f4;
}

.no-data {
  text-align: center;
}

.no-data img {
  margin-top: 3rem;
  width: 5rem;
}

.no-data-title {
  color: #cdcdcd;
  text-align: center;
  font-size: 14px;
  margin-top: 0.5rem;
}
</style>